<template>
  <div class="bind-box-task">
    <div class="box-item" v-for="(item, index) in list" :key="index">
      <div class="left">
        <header>
          <img src="@/assets/task/box.png" alt="" srcset="" />
          <span>每日对战</span>
        </header>
        <div class="use">
          每日对战消耗{{ item.lim}}披萨币（<span style="color: #e9b108">{{
            item.ls
          }}</span
          >/{{ item.lim }}）
        </div>
        <div class="jiangli">
          任务奖励： 保底{{ item.min }}
          <img src="@/assets/pizzaking/pizza-token.svg" alt="披萨币" />
          最高{{ item.max }}
          <img src="@/assets/pizzaking/pizza-token.svg" alt="披萨币" />
        </div>
      </div>
      <button type="button" class="right" data-pk-sound-click @click="consumeRecharge(item)">
        {{ getActionText(item) }}
      </button>
    </div>
  </div>
</template>

<script>
import { playUiSound } from "@/utils/pizzaSound";

export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getBindBoxTaskList();
  },
  methods: {
    async getBindBoxTaskList() {
      const params = {
        player_id: localStorage.getItem("id"),
      };
      const { data } = await this.$axios.post(
        "/index/Activity/battle_reward_info",
        this.$qs.stringify(params)
      );
      this.list = data.data.info;
    },
    getActionText(item) {
      if (item.status == 1) {
        return "立即领取";
      }
      if (item.status == 2) {
        return "已领取";
      }
      return "立即前往";
    },
    async consumeRecharge(item) {
      if (item.status == 1) {
        const params = {
          id: item.id,
          player_id: localStorage.getItem("id"),
        };
        const { data } = await this.$axios.post(
          "/index/Activity/battle_task",
          this.$qs.stringify(params)
        );
        if (data.status) {
          playUiSound("reward");
          this.$message.success("领取成功");
          this.getBindBoxTaskList();
        } else {
          this.$message.error(data.msg);
        }
      } else if (item.status == 2) {
        this.$message.error("奖励已领取");
      } else {
        this.$router.push({
          path: "/Lucky",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bind-box-task {
  color: #fff;
  padding: 10px;
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  .box-item {
    background-color: #343a40;
    padding: 10px;
    display: flex;
    max-width: 500px;
    align-items: center;
    border-radius: 5px;
    .left {
      flex: 1;
      header {
        display: flex;
        align-items: center;
        font-size: 15px;
        img {
          width: 30px;
          margin-right: 7px;
        }
      }
      .use {
        margin: 10px 0;
        font-size: 16px;
      }
      .jiangli {
        display: flex;
        align-items: center;
        font-size: 12px;
        img {
          width: 15px;
          margin: 0 5px;
        }
      }
    }

    .right {
      width: 60px;
      font-size: 14px;
      color: #e9b10e;
      font-weight: bold;
      border: 0;
      cursor: pointer;
    }
  }
}
</style>
